import PageContainer from '@zenbusiness/zui/PageContainer';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledPageContainer = superstyled({
  name: 'ZuiPageContainer',
  slot: 'Root',
  tag: PageContainer,
  styles: ({ theme }) => ({
    marginBlock: theme.spacing(1),

    [theme.breakpoints.up('md')]: {
      marginBlock: theme.spacing(2)
    },

    [theme.breakpoints.up('lg')]: {
      marginBlock: theme.spacing(3)
    }
  })
});
